import { ServiceType } from "@/constants/enum";
import { Merchant } from "@/dto/merchant";
import { Service } from "@/dto/service";

export const isBusinessOpen = (
  merchant: Merchant,
  isDineIn: boolean = false,
  activeDaypartMenu: boolean = true
): boolean => {
  if (isDineIn) {
    if (!activeDaypartMenu) return false;

    const dineinService = merchant.services.find(
      (s: Service) => s.type === ServiceType.DINE_IN
    );
    const isDineInClosed =
      merchant.serviceHoursInformation?.DINE_IN?.serviceHoursState === "CLOSED";
    if (dineinService && !isDineInClosed) {
      return true;
    } else {
      return false;
    }
  }

  const service = merchant?.services.find(
    (s: Service) =>
      s.type === ServiceType.PICKUP || s.type === ServiceType.WEBSITE
  );
  if (!service || !service.enabled) {
    if (merchant.isRestaurant || merchant.isRetail) {
      const curbsideService = merchant.services.find(
        (s: Service) => s.type === ServiceType.CURBSIDE
      );
      if (
        (!curbsideService || !curbsideService.enabled) &&
        !merchant?.isDeliveryEnabled
      ) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  return true;
};
